module.exports = __webpack_public_path__ + "static/media/eighth_veterans_memorial.a83b76ac.mp4";